import { useEffect } from "react";
import useLocalStorage from "./UseLocalStorage";
import i18n from "../i18n";

const LANGUAGES = ["uk", "en"];

// Shared by Header.js (MainHeader's own picker) and Tournament.js (the
// in-page TournamentMenu's picker, since it moved out of Header.js's tree) -
// was previously duplicated only inside Header.js.
export default function useAppLanguage() {
    const userBrowserLanguage = navigator.language || navigator.userLanguage;
    const [language, setLanguage] = useLocalStorage(
        'language',
        LANGUAGES.indexOf(userBrowserLanguage) > -1 ? userBrowserLanguage : "uk"
    );

    useEffect(() => {
        if (!language) return;
        if (i18n.isInitialized) {
            i18n.changeLanguage(language);
        } else if (i18n.on) {
            i18n.on('initialized', () => {
                i18n.changeLanguage(language);
            });
        }
    }, [language]);

    const handleLanguageChange = (lang) => () => {
        i18n.changeLanguage(`${lang}`);
        setLanguage(`${lang}`);
    };

    return { language, handleLanguageChange };
}
